import {
    SET_FORM_DATA_FROM_TABLE_ROW,
    SET_IS_EDITING_USER,
    SET_IS_CREATING_USER,
    SET_ALL_USERS
} from "../actions/types";

const initialState = {
    formDataFromTableRow: {},
    isEditingUser: false,
    isCreatingUser: false,
    allUsers: []
};

const UserManagerReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_FORM_DATA_FROM_TABLE_ROW:
            return { ...state, formDataFromTableRow: payload };

        case SET_IS_EDITING_USER:
            return { ...state, isEditingUser: payload };

        case SET_IS_CREATING_USER:
            return { ...state, isCreatingUser: payload };
        case SET_ALL_USERS:
            return {...state, allUsers: payload}

        default:
            return state;
    }
};

export default UserManagerReducer;